export default {
  "daily_by_time_zone_world_clock": "世界时钟",
  "daily_by_time_zone_world_clock_show_more": "更多",
  "daily_by_time_zone_world_clock_show_less": "收起",
  "daily_by_time_zone_world_clock_setting": "设置时钟",
  "daily_by_time_zone_world_clock_setting_confirm": "确认",
  "daily_by_time_zone_world_clock_setting_cancel": "取消",
  "daily_by_time_zone_world_clock_setting_defaults": "游戏默认时区",
  "daily_by_time_zone_world_clock_setting_customizeds": "自定义展示时区",
  "daily_by_time_zone_world_clock_setting_search": "搜索",
  "daily_by_time_zone_world_clock_setting_select_all": "全选",
  "daily_by_time_zone_world_clock_setting_search_no_result": "无匹配项",
  "daily_by_time_zone_world_clock_setting_select_only_one_tip": "请至少保留一个时钟展示",
  "daily_by_time_zone_world_clock_setting_select_more_than_24_tip": "最多展示24个时钟",

  'daily_by_time_zone_selector_region_label': '地区',
  'daily_by_time_zone_selector_country_label': '国家',
  'daily_by_time_zone_selector_global': '全球',
  'daily_by_time_zone_selector_all': '全部',
  'daily_by_time_zone_selector_total': '全部',
  'daily_by_time_zone_selector_region_des': '按当地时区汇总，展示全球的去重用户数据。',
  'daily_by_time_zone_selector_zone_des': '按各区服当地时区汇总，展示全部区服的去重用户数据。',
  // 趋势图
  'daily_by_time_zone_trend_sdlw': '上周同期',
  'daily_by_time_zone_trend_avg': '平均值',
  'daily_by_time_zone_trend_sum': '汇总值',
  'daily_by_time_zone_trend_expand': '更多',
  'daily_by_time_zone_trend_fold': '收起',

  // 宽表标题
  'daily_by_timezone_Key_Metrics_Comparison': '关键指标对比',
  // 页面标题
  'daily_by_timezone_title': '运营总况日报(分时区)',
  // 页面副标题
  'daily_by_timezone_sub_title_country': "本页展示按国家当地时区口径计算的数据.",
  'daily_by_timezone_sub_title_zone': "本页展示按区服当地时区口径计算的数据.",
  'daily_by_timezone_sub_title': "此页面显示为按国家当地时区分别计算的数据。T日期的数据(比如，12月1日)，会在T+2（12月3日）早上9点（UTC +8）更新。"
}
